import { Component, OnInit, AfterViewInit, ViewChild  } from '@angular/core';
// import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormArray } from '@angular/forms';
import { LoginService } from '../login/login.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { TemplateService } from '../template-listing/template.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from '@angular/common';




declare var tinymce: any;


@Component({
  selector: 'app-template-mapping',
  templateUrl: './template-mapping.component.html',
  styleUrls: ['./template-mapping.component.css']
})
export class TemplateMappingComponent {
   @ViewChild('editor') editor: EditorComponent | undefined;
  reportForm!: FormGroup
  token: any
  productDetails: any = []
  TemplateDetails: any;
  editorInstance: any;
  // template-mapping.component.ts
editorConfig: any = {
  width: 950,
  height: 700,
  menubar: 'file edit view insert format tools table help',
  plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
  editimage_cors_hosts: ['picsum.photos'],
  toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
  toolbar_sticky: true,
  autosave_ask_before_unload: true,
  autosave_interval: '30s',
  autosave_prefix: '{path}{query}-{id}-',
  autosave_restore_when_empty: false,
  autosave_retention: '2m',
  image_advtab: true,
  link_list: [
    { title: 'My page 1', value: 'https://www.tiny.cloud' },
    { title: 'My page 2', value: 'http://www.moxiecode.com' }
  ],
  image_list: [
    { title: 'My page 1', value: 'https://www.tiny.cloud' },
    { title: 'My page 2', value: 'http://www.moxiecode.com' }
  ],
  image_class_list: [
    { title: 'None', value: '' },
    { title: 'Some class', value: 'class-name' }
  ],
  importcss_append: true,
  valid_elements: '*[*]',
  advcode_inline: true,
  extended_valid_elements: 'style[*]'
};





  constructor(private formBuilder: FormBuilder, private router: Router, private http: HttpClient, private loginService: LoginService,
    private templateService:TemplateService,private spinner:NgxSpinnerService,private location: Location
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    this.reportForm = this.formBuilder.group({
      templateName:[],
      subject: [],
      pdfFormat: [],
      uploads: this.formBuilder.array([])
    });


    this.TemplateDetails = JSON.parse(localStorage.getItem("TemplateDetails") || '{}');
    console.log(this.TemplateDetails)

    if (this.TemplateDetails?.flag == 'Edit') {
    

      this.reportForm.get('templateName')?.setValue(this.TemplateDetails.templateName);
      this.reportForm.get('subject')?.setValue(this.TemplateDetails.subject);
      // this.reportForm.get('pdfFormat')?.setValue(this.TemplateDetails.body);
      
      if(this.TemplateDetails.attachment)
       this.setUploads(this.TemplateDetails.attachment);


    }

    // ... initialize form etc

  }

  navigateBack(){
    //  this.router.navigate(['work-page'])
     this.location.back();
  }

  ngAfterViewInit() {
    console.log("ngAfter")

    const useDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const isSmallScreen = window.matchMedia('(max-width: 1023.5px)').matches;



    tinymce.init({
      selector: '#quote',
      plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
      editimage_cors_hosts: ['picsum.photos'],
      menubar: 'file edit view insert format tools table help',
      toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
      toolbar_sticky: true,
      // toolbar_sticky_offset: isSmallScreen ? 102 : 108,
      autosave_ask_before_unload: true,
      autosave_interval: '30s',
      autosave_prefix: '{path}{query}-{id}-',
      autosave_restore_when_empty: false,
      autosave_retention: '2m',
      image_advtab: true,
      link_list: [
        { title: 'My page 1', value: 'https://www.tiny.cloud' },
        { title: 'My page 2', value: 'http://www.moxiecode.com' }
      ],
      image_list: [
        { title: 'My page 1', value: 'https://www.tiny.cloud' },
        { title: 'My page 2', value: 'http://www.moxiecode.com' }
      ],
      image_class_list: [
        { title: 'None', value: '' },
        { title: 'Some class', value: 'class-name' }
      ],
      importcss_append: true,
      file_picker_callback: (callback: any, value: any, meta: any) => {
        /* Provide file and text for the link dialog */
        if (meta.filetype === 'file') {
          callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
        }

        /* Provide image and alt text for the image dialog */
        if (meta.filetype === 'image') {
          callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
        }

        /* Provide alternative source and posted for the media dialog */
        if (meta.filetype === 'media') {
          callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
        }
      },
      templates: [
        { title: 'New Table', description: 'creates a new table', content: '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>' },
        { title: 'Starting my story', description: 'A cure for writers block', content: 'Once upon a time...' },
        { title: 'New list with dates', description: 'New List with dates', content: '<div class="mceTmpl"><span class="cdate">cdate</span><br><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>' }
      ],
      template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
      template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
      height: 700,
      image_caption: true,
      quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
      noneditable_class: 'mceNonEditable',
      toolbar_mode: 'sliding',
      contextmenu: 'link image table',
      skin: useDarkMode ? 'oxide-dark' : 'oxide',
      content_css: useDarkMode ? 'dark' : 'default',
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
    });






  }

  ngOnDestroy() {
    tinymce.remove('#quote');
  }


onEditorInit(event: any) {
if (this.TemplateDetails?.body) {
  this.http.get(this.TemplateDetails.body, { responseType: 'text' }).subscribe({
    next: (htmlContent) => {
      this.reportForm.get('pdfFormat')?.setValue(htmlContent);
      if (this.editorInstance) this.editorInstance.setContent(htmlContent);
    },
    error: (err) => {
      console.error('Failed to fetch HTML content', err);
      // fallback: show empty editor or raw body
      const fallbackContent = this.TemplateDetails.body || '';
      this.reportForm.get('pdfFormat')?.setValue(fallbackContent);
      if (this.editorInstance) this.editorInstance.setContent(fallbackContent);
    }
  });
}

}


  setUploads(data: any[]) {
    const arr = data.map(item =>
      this.formBuilder.group({
        filename: [item.filename],
        s3url: [item.s3url]
      })
    );
    const formArray = this.formBuilder.array(arr);
    this.reportForm.setControl('uploads', formArray);
  }

  processFile(event: any) {
    console.log("process file")

    const uploadedFile = event.target.files[0];
    if (event.target.files[0]) {
       this.loginService.UploadMultiple(event.target.files, this.token)
        .subscribe((response: any) => {
      
        if (response.data) {
              this.http
                .get(
                response.data[0],
                  { responseType: 'text' }
                )
                .subscribe((htmlContent) => {
                  // assuming you have a form control named pdfFormat
                  this.reportForm.get('pdfFormat')?.setValue(htmlContent);
                });
        }
      })

    };

  }

  onSubmit() {
    console.log(this.reportForm.value);

    let info:any = this.reportForm.value;
    info.body = info.pdfFormat;
    info.attachment = this.reportForm.value.uploads;

    console.log(info)

    this.spinner.show()

      if(info.pdfFormat){
         var data ={
            pdfFormat : info.pdfFormat.toString(),
            s3path:"template"
          }
          this.templateService.uploadTemplate(this.token , data)
            .subscribe(
              (res:any) => {
               
                console.log(res);
                if(res.url){
                  info.body = res.url;

                      if (this.TemplateDetails?.flag == 'Edit') {

                        info.id = this.TemplateDetails._id;
                        console.log(info)
                        this.templateService.updateTemplate(this.token , info)
                              .subscribe((response: any) => {
                                 this.spinner.hide();
                                if (response.status === 1) {
                                  Swal.fire({
                                            title: "Successfully Updated!",
                                            text: "Your template has been updated.",
                                            icon: "success"
                                          });

                                  this.router.navigate(["/template-listing"])

                                }
                          })
                          
                      }else{
                        
                            this.templateService.addTemplate(this.token , info)
                              .subscribe((response: any) => {
                                 this.spinner.hide();
                                if (response.status === 100) {

                                  Swal.fire({
                                            title: "Successfully Added!",
                                            text: "Your template has been created.",
                                            icon: "success"
                                          });

                                  this.router.navigate(["/template-listing"])

                                }
                              })
                      }
                    }else{
                        this.spinner.hide();
                    }
                  })
      }else{
           if (this.TemplateDetails?.flag == 'Edit') {

              info.id = this.TemplateDetails._id;
              console.log(info)
              this.templateService.updateTemplate(this.token , info)
                    .subscribe((response: any) => {
                       this.spinner.hide();
                      if (response.status === 1) {
                        Swal.fire({
                                  title: "Successfully Updated!",
                                  text: "Your template has been updated.",
                                  icon: "success"
                                });

                        this.router.navigate(["/template-listing"])

                      }
                })
                
            }else{
              
                  this.templateService.addTemplate(this.token , info)
                    .subscribe((response: any) => {
                       this.spinner.hide();
                      if (response.status === 100) {

                        Swal.fire({
                                  title: "Successfully Added!",
                                  text: "Your template has been created.",
                                  icon: "success"
                                });

                        this.router.navigate(["/template-listing"])

                      }
                    })
            }
      }  
              
   }

 
  get uploads(): FormArray {
    return this.reportForm.get('uploads') as FormArray;
  }

  addUpload() {
    const uploadGroup = this.formBuilder.group({
      filename: ['', Validators.required],
      s3url: ['']
    });
    this.uploads.push(uploadGroup);
  }

  removeUpload(index: number) {
    this.uploads.removeAt(index);
  }

  onFileSelected(event: any, index: number) {
    console.log(event.target.files)
    this.loginService.UploadMultiple(event.target.files, this.token)
      .subscribe((response: any) => {
        if (response.status === 1) {

          Swal.fire("Uploaded")
          console.log(event.target.files[0].name)

          this.uploads.at(index).patchValue({ s3url: response.data[0] });
          this.uploads.at(index).patchValue({ filename: event.target.files[0].name });
        }
      })


  }



}
